import React, { useState } from 'react';
import Select from 'react-select';
//@ts-ignore
import {Checkbox} from 'react-icheck';

interface printCheckBoxProps {
  disabled?: boolean;
  deidentified: boolean;
  blackWhite: boolean;
  updateBlackWhite: (value: boolean) => void;
  updateDeIdentify: (value: boolean) => void;
  has_deidentified_role: boolean;
}
const dropDownStyle: React.CSSProperties = { 
  width: '100px', 
  fontSize: '13px', 
  color: '#626262', 
  fontWeight: '500', 
  textTransform: 'none',
  letterSpacing: '0px'
}

const PrintCheckBoxes: React.FC<printCheckBoxProps> = ({ updateDeIdentify, updateBlackWhite, deidentified, blackWhite, disabled, has_deidentified_role }) => {
  return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                <h5 style={dropDownStyle}>Options</h5>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Checkbox
                            id="Black/White Icons"
                            name="Icons"
                            onChange={(e:any, checked:boolean) => {
                                updateBlackWhite(checked)
                              }}
                            checkboxClass="icheckbox_flat-green"
                            increaseArea="20%"
                            checked={blackWhite}
                        />
                        <label htmlFor="Black/White Icons" className='print-labels' >Black/White Icons</label>
                    </div>
                    {/* hide for deidentified users */}
                    {!has_deidentified_role &&
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Checkbox
                            id="deIdentify"
                            name="deIdentify"
                              onChange={(e:any, checked:boolean) => {
                                updateDeIdentify(checked)
                              }}
                            checkboxClass="icheckbox_flat-green"
                            increaseArea="20%"
                            checked={deidentified}
                        />
                        <label htmlFor="deIdentify" className='print-labels'>De-identified</label>
                      </div>
                    }
                </div>
            </div>
        </>
    )
};

export default PrintCheckBoxes;
